import Icon from 'assets/components/icon/Icon';
import CheckInput from 'assets/components/inputs/check/CheckInput';
import DateInput from 'assets/components/inputs/dateInput/DateInput';
import { inputStyles } from 'assets/components/inputs/Input';
import NumberInput from 'assets/components/inputs/number/NumberInput';
import TextInput from 'assets/components/inputs/text/TextInput';
import { getLocales } from 'assets/locales/Locale';
import ObjectTable from 'assets/templates/objectTable/ObjectTable';
import { ValidationRegex } from 'assets/utils/data/Regex';
import ClaimTypeDataPointInputType from 'models/enums/ClaimTypeDataPointInputType';

export function getVisibleDataPoints(dataPoints: Utils.FormData<Model.IClaimJobDataPoint[]> | undefined) {
  return (dataPoints || []).filter((dataPoint) => dataPoint?.isVisible !== false && !dataPoint?.sourcePropertyPath);
}

const ClaimJobDataPointsInputs = ({
  dataPoints,
  onUpdate,
}: {
  dataPoints: Utils.FormData<Model.IClaimJobDataPoint[]>;
  onUpdate(value: string, dataPointId: number): void;
}) => {
  const { lang } = getLocales();

  return (
    <ObjectTable
      paths={[]}
      data={getVisibleDataPoints(dataPoints)}
      renderRow={({ data: row }) => {
        const update = (value: string) => {
          if (typeof row?.claimTypeDataPointId === 'number') {
            onUpdate(value, row.claimTypeDataPointId);
          }
        };

        return (
          <tr key={row.claimTypeDataPointId}>
            <td>{row.name}</td>
            <td>
              {row.type === ClaimTypeDataPointInputType.Number ? (
                <NumberInput
                  name="value"
                  value={Number(row.value)}
                  error={row.isRequired && !row.value && lang.isRequired}
                  onChange={({ value }) => update(String(value))}
                />
              ) : row.type === ClaimTypeDataPointInputType.Any ? (
                <TextInput
                  name="value"
                  value={row.value}
                  error={row.isRequired && !row.value && lang.isRequired}
                  onChange={({ value }) => update(value)}
                />
              ) : row.type === ClaimTypeDataPointInputType.Text ? (
                <TextInput
                  name="value"
                  value={row.value}
                  error={row.isRequired && !row.value && lang.isRequired}
                  onChange={({ value }) => {
                    if (value === '' || ValidationRegex.letters.test(value)) update(value);
                  }}
                />
              ) : row.type === ClaimTypeDataPointInputType.Alphanumeric ? (
                <TextInput
                  name="value"
                  value={row.value}
                  error={row.isRequired && !row.value && lang.isRequired}
                  onChange={({ value }) => {
                    if (!ValidationRegex.alphanumeric.test(value)) update(value);
                  }}
                />
              ) : row.type === ClaimTypeDataPointInputType.Date ? (
                <DateInput
                  name="value"
                  value={row.value}
                  error={row.isRequired && !row.value && lang.isRequired}
                  isLocal={true}
                  onChange={({ value }) => update(value)}
                />
              ) : row.type === ClaimTypeDataPointInputType.Boolean ? (
                <CheckInput
                  style={{ input: { justifyContent: 'flex-start' } }}
                  name="value"
                  value={row.value === 'true' ? true : false}
                  // error={row.isRequired && !row.value && lang.isRequired}
                  onChange={({ value }) => {
                    update(value.toString());
                  }}
                  class={inputStyles.check.switch}
                />
              ) : row.type === ClaimTypeDataPointInputType.Price ? (
                <NumberInput
                  name="value"
                  value={Number(row.value)}
                  error={row.isRequired && !row.value && lang.isRequired}
                  onChange={({ value }) => {
                    update(String(value));
                  }}
                  iconBefore={<Icon class="fas-dollar-sign" />}
                  roundOnBlur
                  step={0.01}
                />
              ) : null}
            </td>
          </tr>
        );
      }}
    />
  );
};

export default ClaimJobDataPointsInputs;
